import { Component, DestroyRef, effect, inject, OnInit } from '@angular/core';
import { FullscreenLayout } from '../../../layout/components/fullscreen-layout/fullscreen-layout';
import { PageHeader } from '../../../layout/components/page-header/page-header';
import { PageTitle } from '../../../layout/components/page-title/page-title';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CurrentUserAvatar } from '../../../user/components/current-user-avatar/current-user-avatar';
import { OrganizationsStore } from '../../store/organizations.store';
import { Button, InputSimple, SwitchBar, SwitchBarOption, TooltipDirective } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { DatePipe } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, Subject } from 'rxjs';
import { ErrorPage } from '../../../../shared/components/error-page/error-page';
import { OrganizationCardSkeleton } from '../../components/organization-card-skeleton/organization-card-skeleton';
import { OrganizationProfilePicturePipe } from '../../pipes/organization-profile-picture-pipe';
import { CurrentUsername } from '../../../user/components/current-username/current-username';
import { TechnicalMonitoringEnabledDirective } from '../../../monitoring/directives/technical-monitoring-enabled.directive';
import { FeedbackFab } from '../../../monitoring/components/feedback-fab/feedback-fab';
import { UserProfileButton } from '../../../user/components/user-profile-button/user-profile-button';
import { FeatureEnabledDirective } from '../../../../shared/directives/feature-enabled';
import { HasRoleDirective } from '../../../../shared/directives/has-role';

import { DisableInDemoModeDirective } from '../../../demo/directives/disable-in-demo-mode';
import { DemoInfoBanner } from '../../../demo/components/demo-info-banner/demo-info-banner';
import { IsDemoModeDirective } from '../../../demo/directives/is-demo-mode';
import { DemoModeActiveDirective } from '../../../demo/directives/demo-mode-active';

@Component({
  selector: 'app-organizations-page',
  imports: [
    FullscreenLayout,
    PageHeader,
    PageTitle,
    RouterLink,
    CurrentUserAvatar,
    Button,
    NgIcon,
    DatePipe,
    TranslocoPipe,
    InputSimple,
    ErrorPage,
    OrganizationCardSkeleton,
    OrganizationProfilePicturePipe,
    CurrentUsername,
    TechnicalMonitoringEnabledDirective,
    FeedbackFab,
    UserProfileButton,
    FeatureEnabledDirective,
    HasRoleDirective,
    SwitchBar,
    SwitchBarOption,
    TooltipDirective,
    DisableInDemoModeDirective,
    DemoInfoBanner,
    IsDemoModeDirective,
    DemoModeActiveDirective,
  ],
  templateUrl: './organizations-page.html',
})
export class OrganizationsPage implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private destroyRef = inject(DestroyRef);
  protected store = inject(OrganizationsStore);

  protected searchQuery = new Subject<string>();

  constructor() {
    effect(() => {
      const query = this.store.searchQuery();
      this.router.navigate([], {
        queryParams: { search: query || null },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    });
  }

  ngOnInit(): void {
    const query = this.activatedRoute.snapshot.queryParamMap.get('search') || '';
    if (this.store.searchQuery() !== query) {
      this.store.setSearchQuery(query);
    }

    this.searchQuery
      .pipe(takeUntilDestroyed(this.destroyRef), debounceTime(300))
      .subscribe((query) => this.store.setSearchQuery(query));
  }

  protected onClickBack() {
    this.router.navigate(['/']);
  }

  protected onSwitchBarChange(value: unknown) {
    if (value === 'broker') {
      this.router.navigate(['/broker']);
    } else {
      this.router.navigate(['/organizations']);
    }
  }
}
